module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/widget-reportes.81d3e0dc.svg";